import React, { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';

export default function GuessTheName() {
  const [characters, setCharacters] = useState([]);
  const [namePool, setNamePool] = useState([]);
  const [current, setCurrent] = useState(null);
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [showAnswer, setShowAnswer] = useState(false);
  const [difficulty, setDifficulty] = useState('medium');

  useEffect(() => {
    fetchCharactersAndNames();
  }, []);

  const getOptionCount = () => {
    if (difficulty === 'easy') return 1;
    if (difficulty === 'hard') return 5;
    return 3;
  };

  const fetchCharactersAndNames = async () => {
    const { data: charactersData, error: charError } = await supabase
      .from('characters')
      .select('*')
      .not('image_blur', 'is', null);

    const { data: nombresData, error: nombreError } = await supabase
      .from('nombres_guess')
      .select('nombre');

    if (charError || nombreError) {
      console.error('Error loading data:', charError || nombreError);
    } else {
      setCharacters(charactersData);
      setNamePool(nombresData.map(n => n.nombre));
      generateRound(charactersData, nombresData.map(n => n.nombre));
    }
  };

  const generateRound = (characterList, allNames) => {
    const filtered = characterList.filter((char) => char.image_blur && char.name);
    const optionCount = getOptionCount();

    if (filtered.length < 1 || allNames.length < optionCount + 1) return;

    const randomCharacter = filtered[Math.floor(Math.random() * filtered.length)];

    const otherNames = allNames
      .filter((name) => name !== randomCharacter.name)
      .sort(() => 0.5 - Math.random())
      .slice(0, optionCount);

    const allOptions = [...otherNames, randomCharacter.name]
      .filter((v, i, a) => a.indexOf(v) === i)
      .sort(() => 0.5 - Math.random());

    setCurrent(randomCharacter);
    setOptions(allOptions);
    setSelected(null);
    setShowAnswer(false);
  };

  const handleSelect = (name) => {
    setSelected(name);
    setShowAnswer(true);
  };

  if (!current) return <div style={{ padding: '2rem' }}>Loading...</div>;

  return (
    <div style={{ textAlign: 'center', padding: '2rem' }}>
      <h2>👀 Guess the Name 🧠</h2>
      <p>TEST YOUR NUBBI KNOWLEDGE and become a Nubbi Master! Can you guess this Nubbi's real name?</p>

      <div style={{ marginBottom: '1.5rem' }}>
        <span style={{ fontWeight: 'bold' }}>Difficulty:</span>
        <button onClick={() => setDifficulty('easy')} style={{ margin: '0 0.5rem' }}>Easy</button>
        <button onClick={() => setDifficulty('medium')} style={{ margin: '0 0.5rem' }}>Medium</button>
        <button onClick={() => setDifficulty('hard')} style={{ margin: '0 0.5rem' }}>Hard</button>
      </div>

      <div style={{ maxWidth: '300px', margin: 'auto' }}>
        <img 
          src={showAnswer ? current.image : current.image_blur} 
          alt="Nubbi" 
          style={{ width: '100%', borderRadius: '12px' }} 
        />
      </div>

      <div style={{ marginTop: '1.5rem' }}>
        {options.map((nameOption, index) => (
          <button
            key={index}
            onClick={() => handleSelect(nameOption)}
            disabled={showAnswer}
            style={{
              margin: '0.5rem',
              padding: '0.75rem 1.5rem',
              fontSize: '1rem',
              fontWeight: 'bold',
              borderRadius: '10px',
              border: selected === nameOption && showAnswer ? '3px solid #22c55e' : '1px solid #ccc',
              backgroundColor: selected === nameOption && showAnswer
                ? nameOption === current.name ? '#22c55e' : '#ef4444'
                : '#f3f4f6',
              cursor: 'pointer'
            }}
          >
            {nameOption}
          </button>
        ))}
      </div>

      {showAnswer && (
        <div style={{ marginTop: '1rem', fontSize: '1.2rem', fontWeight: 'bold' }}>
          {selected === current.name
            ? `✅ Correct! This Nubbi's name is: ${current.name}`
            : `❌ Oops! The correct name is: ${current.name}`}
        </div>
      )}

      {showAnswer && (
        <button
          onClick={() => generateRound(characters, namePool)}
          style={{
            marginTop: '2rem',
            padding: '0.75rem 1.5rem',
            fontSize: '1rem',
            backgroundColor: '#3B82F6',
            color: '#fff',
            border: 'none',
            borderRadius: '12px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          Next Nubbi
        </button>
      )}
    </div>
  );
}
